import { Component, Inject, OnInit } from '@angular/core'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatButton } from '@angular/material/button'
import { MatProgressBar } from '@angular/material/progress-bar'
import { Clipboard } from '@angular/cdk/clipboard'
import { ReservationScheduleService } from '../../../core/services/purchase-reservation/reservation-schedule/reservation-schedule.service'
import { ServiceOrderService } from '../../../core/services/service/service-order/service-order.service'
import { PurchaseServiceOrderService } from '../../../core/services/purchase-reservation/purchase-service-order/purchase-service-order.service'
import { TableListPurchaseReservationServiceOrderComponent } from '../../../shared/components/table-list-purchase-reservation-service-order/table-list-purchase-reservation-service-order.component'
import { PurchaseReservationEditModalComponent } from '../purchase-reservation-edit-modal/purchase-reservation-edit-modal.component'
import { PurchaseReservationEditBatchModalComponent } from '../purchase-reservation-edit-batch-modal/purchase-reservation-edit-batch-modal.component'
import { DialogConfirmComponent } from '../../../shared/components/dialog-confirm/dialog-confirm.component'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { convertCurrency } from '../../../shared/utils/utils'

@Component({
  selector: 'purchase-reservation-tg-view',
  imports: [MatButton, MatProgressBar, TableListPurchaseReservationServiceOrderComponent],
  templateUrl: './purchase-reservation-tg-view.component.html',
  styleUrl: './purchase-reservation-tg-view.component.scss',
  standalone: true,
})
export class PurchaseReservationTgViewComponent implements OnInit {
  constructor(
    private agendaReservaService: ReservationScheduleService,
    private serviceOrderService: ServiceOrderService,
    private comprasOrdemServicoService: PurchaseServiceOrderService,
    private dialogRef: MatDialogRef<PurchaseReservationTgViewComponent>,
    private dialog: MatDialog,
    private snackbarCustomService: SnackbarCustomService,
    private clipboard: Clipboard,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data
  }

  item: any = {}
  loading = false
  itemsList: any[] = []
  selectionMode = false
  selectedCosIds: string[] = []
  private readonly selectColumn = {
    keyColumn: 'select',
    key: 'select',
    description: '',
  }

  columns: any[] = [
    {
      keyColumn: 'os_info',
      key: 'os_info',
      description: 'OS / TG',
    },
    {
      keyColumn: 'period',
      key: 'period',
      description: 'Período',
    },
    {
      keyColumn: 'trecho',
      key: 'trecho',
      description: 'Trecho',
    },
    {
      keyColumn: 'pax',
      key: 'pax',
      description: 'Pax',
    },
    {
      keyColumn: 'servico_info',
      key: 'servico_info',
      description: 'Serviço',
    },
    {
      keyColumn: 'status_info',
      key: 'status_info',
      description: 'Status',
    },
    {
      keyColumn: 'fornecedor',
      key: 'fornecedor',
      description: 'Fornecedor',
    },
    {
      keyColumn: 'action',
      key: { edit: true, copyLink: true, sendEmail: true, sendToFleet: true },
      description: 'Ações',
    },
  ]

  ngOnInit(): void {
    this.getListItems()
  }

  close() {
    this.dialogRef.close()
  }

  formatCurrency(value: any): string {
    return value != null ? `R$ ${convertCurrency(value)}` : '-'
  }

  getListItems() {
    this.loading = true
    this.agendaReservaService.getOsByTg(this.item.propostaId).subscribe({
      next: (response: any) => {
        this.itemsList = response.data ?? []
      },
      error: (err: any) => {
        this.loading = false
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  editItem(item: any) {
    const dialogRef = this.dialog.open(PurchaseReservationEditModalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '1100px',
      maxWidth: '95vw',
      data: { item },
    })
    dialogRef.componentInstance.response.subscribe((response: any) => {
      if (response) {
        this.getListItems()
      }
    })
  }

  copyLinkItem(item: any) {
    this.comprasOrdemServicoService.getLinkAcessoWhatsApp(item.cosId).subscribe({
      next: (response: any) => {
        const link = response.data?.linkWhatsApp
        if (link && this.clipboard.copy(link)) {
          this.snackbarCustomService.success(
            'Link copiado para a área de transferência.',
          )
        } else {
          this.snackbarCustomService.warning('Link indisponível para esta OS.')
        }
      },
      error: (err: any) => {
        this.snackbarCustomService.errorRequest(err)
      },
    })
  }

  sendEmailItem(item: any) {
    this.comprasOrdemServicoService
      .notificar({
        comprasOsIds: [item.cosId],
        enviarEmail: true,
        gerarLinkWhatsApp: false,
      })
      .subscribe({
        next: (response: any) => {
          const emailsEnviados = response.data?.emailsEnviados ?? 0
          if (emailsEnviados > 0) {
            this.snackbarCustomService.success(
              'E-mail enviado ao fornecedor com sucesso.',
            )
          } else {
            this.snackbarCustomService.warning(
              'Nenhum e-mail enviado (OS sem fornecedor atribuído).',
            )
          }
        },
        error: (err: any) => {
          this.snackbarCustomService.errorRequest(err)
        },
      })
  }

  startSelection() {
    this.selectionMode = true
    this.selectedCosIds = []
    if (!this.columns.some((c) => c.keyColumn === 'select')) {
      this.columns = [this.selectColumn, ...this.columns]
    }
  }

  cancelSelection() {
    this.selectionMode = false
    this.selectedCosIds = []
    this.columns = this.columns.filter((c) => c.keyColumn !== 'select')
  }

  toggleSelectItem(item: any) {
    const index = this.selectedCosIds.indexOf(item.codigoOs)
    if (index === -1) {
      this.selectedCosIds.push(item.codigoOs)
    } else {
      this.selectedCosIds.splice(index, 1)
    }
  }

  toggleSelectAllItems(checked: boolean) {
    this.selectedCosIds = checked
      ? this.itemsList.map((item: any) => item.codigoOs)
      : []
  }

  confirmSelection() {
    if (this.selectedCosIds.length === 0) {
      this.snackbarCustomService.warning('Selecione ao menos uma OS.')
      return
    }
    const dialogRef = this.dialog.open(PurchaseReservationEditBatchModalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '900px',
      maxWidth: '95vw',
      data: {
        comprasOsIds: [...this.selectedCosIds],
        itens: this.itemsList.filter((item: any) =>
          this.selectedCosIds.includes(item.codigoOs),
        ),
      },
    })
    dialogRef.componentInstance.response.subscribe((response: any) => {
      if (response) {
        this.cancelSelection()
        this.getListItems()
      }
    })
  }

  sendToFleetItem(item: any) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Enviar para Frota',
        message: `Deseja enviar a OS ${item.codigoOs} para Frota?`,
        confirmLabel: 'Enviar',
      },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) return
      this.serviceOrderService
        .transferirResponsavel(item.codigoOs, 'FROTA')
        .subscribe({
          next: () => {
            this.snackbarCustomService.success('OS enviada para Frota com sucesso.')
            this.getListItems()
          },
          error: (err: any) => {
            this.snackbarCustomService.errorRequest(err)
          },
        })
    })
  }
}
